import axios from 'axios'
import { add_job, add_jobs } from '../jobSlice'

async function edit_job(token,jobs,dispatch,setOpen,setMessage,data,setLoading,navigate){
    
    setLoading(true)

    console.log(data)

    const editJob = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}edit-job/`,data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${token}`
            }
    }).catch(err=>{
        console.log(err)
        setMessage("error while editing,check your connection")
        setOpen(true)
        setLoading(false)
    })

    if (editJob?.status == 200 && editJob?.data?.success == true) {

        setMessage("Job edited successfully")
        setOpen(true)

        const filterJobs = jobs?.filter(item=>item?.id !== data?.id)
        
        dispatch(add_job(editJob?.data?.job))
        dispatch(add_jobs([...filterJobs,editJob?.data?.job]))

        setLoading(false)
        navigate("/jobInfo")

    }else{
        console.log(editJob?.data)
        setMessage(editJob?.data?.message)
        setOpen(true)
        setLoading(false)
    }

}

export default edit_job